import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listPartidos:[],
  // newRole:[],
};

export const mutations = {
  GET_PARTIDOS({ context }, partidos) {
    let partidos_array = [];
    Object.entries(partidos).forEach(([key, val]) => partidos_array.push(val));
    return (state.listPartidos = partidos_array);
  }
};

export const actions = {
  GET_PARTIDOS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // commit("SET_LOADING", false);
          commit("GET_PARTIDOS", response.data.data.partidos);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_DISTRITO({ commit }, distrito) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(distrito)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_DISTRITO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  EDIT_DISTRITO({ commit }, distrito) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(distrito)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          // commit("EDIT_DISTRITO", response.data.data.partidos);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  DELETE_DISTRITO({ commit }, distrito) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      console.log(distrito);
      commit("SET_LOADING", true);
      ApiService.delete(distrito)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("DELETE_DISTRITO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  }
};

export const getters = {//leer datos
  getPartidos: state => state.listPartidos,
  // newRole: state => state.newRole,
};
